import React from 'react';
import FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ColorConstants from 'constants/ColorConstants';

const GLYPH_ICONS = {
  'align-left': FormatAlignLeftIcon,
  'triangle-bottom': ArrowDropDownIcon
};

// Explicit testids: MUI only auto-adds data-testid in development builds,
// and the Cypress suite selects these icons against production packs.
const GLYPH_TEST_IDS = {
  'align-left': 'FormatAlignLeftIcon',
  'triangle-bottom': 'ArrowDropDownIcon'
};

function GlypiconParagraph({
  borderRadius,
  fontSize,
  color,
  marginTop,
  glyph
}) {
  //const CIRCLE_SIZE = 30;
  const circleSize = `30px`;
  const GlyphIcon = GLYPH_ICONS[glyph];

  return (
    <div
      style={{
        width: circleSize,
        height: circleSize,
        borderRadius: borderRadius || "20%",
        fontSize: fontSize || "15px",
        color: "#fff",
        lineHeight: circleSize,
        textAlign: "center",
        background: color || ColorConstants.ACTIVE_BUTTON_BLUE,
        marginTop: marginTop,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}
    >
      {GlyphIcon && <GlyphIcon data-testid={GLYPH_TEST_IDS[glyph]} fontSize="inherit" />}
    </div>
  );
}

export default GlypiconParagraph;
